export default __webpack_public_path__ + "static/media/gallery-wip-greeblies_09.67bc8877.jpg";